import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-2" },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [_c("app-title", { attrs: { texto: "ATIVIDADES DE INTERESSE" } })],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: { texto: "ÁREAS DE CULTURA E ARTE", cor: "secondary" },
              }),
            ],
            1
          ),
          _vm.relatorio.areasCultura.length > 0
            ? _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("bar-chart", {
                    attrs: {
                      categorias: _vm.dadosBarChartCultura.categorias,
                      dados: _vm.dadosBarChartCultura.dados,
                      titulo:
                        "Comparativo de Interesses<br>Atividades de Cultura e Arte",
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.ano}`,
                      "descricao-eixo-y": "Quantidade",
                      legenda: _vm.legendaBarChart,
                      tooltip: _vm.tooltipBarChart,
                      "is-get-svg": _vm.isGetSvg.cultura.bar,
                    },
                    on: { svg: (value) => (_vm.svg.cultura.bar = value) },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: {
                  texto: "RESULTADO: ÁREAS DE CULTURA E ARTE",
                  cor: "secondary",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("tabela-resultado-area", {
                attrs: {
                  relatorio: _vm.relatorio,
                  titulo: "Cultura e Arte",
                  "area-attr": "areasCultura",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: {
                  texto: "INSTRUTOR DE CULTURA E ARTE",
                  cor: "secondary",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("pie-chart", {
                attrs: {
                  titulo:
                    "Comparativo de Interesses<br>Instrutor de Cultura e Arte",
                  fonte: `Sistema Desenvolva, ${_vm.ano}`,
                  dados: _vm.dadosPieChartCultura,
                  "is-get-svg": _vm.isGetSvg.cultura.pie,
                },
                on: { svg: (value) => (_vm.svg.cultura.pie = value) },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: {
                  texto: "RESULTADOS: INSTRUTOR DE CULTURA E ARTE",
                  cor: "secondary",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("tabela-resultado-instrutor", {
                attrs: {
                  relatorio: _vm.relatorio,
                  titulo: "Cultura e Arte",
                  icone: "palette",
                  "interesses-attr": "areasCultura",
                  "is-instrutor-attr": "isInstrutorCultura",
                  "cursos-attr": "cursosCultura",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: { texto: "ÁREAS DE ESPORTE", cor: "secondary" },
              }),
            ],
            1
          ),
          _vm.relatorio.areasEsporte.length > 0
            ? _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c("bar-chart", {
                    attrs: {
                      categorias: _vm.dadosBarChartEsporte.categorias,
                      dados: _vm.dadosBarChartEsporte.dados,
                      titulo:
                        "Comparativo de Interesses<br>Atividades de Esporte",
                      fonte: `Fonte: Sistema Desenvolva, ${_vm.ano}`,
                      "descricao-eixo-y": "Quantidade",
                      legenda: _vm.legendaBarChart,
                      tooltip: _vm.tooltipBarChart,
                      "is-get-svg": _vm.isGetSvg.esporte.bar,
                    },
                    on: { svg: (value) => (_vm.svg.esporte.bar = value) },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: {
                  texto: "RESULTADOS: ÁREAS DE ESPORTE",
                  cor: "secondary",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("tabela-resultado-area", {
                attrs: {
                  relatorio: _vm.relatorio,
                  titulo: "Esporte",
                  "area-attr": "areasEsporte",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: { texto: "INSTRUTOR DE ESPORTE", cor: "secondary" },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("pie-chart", {
                attrs: {
                  titulo: "Comparativo de Interesses<br>Instrutor de Esporte",
                  fonte: `Sistema Desenvolva, ${_vm.ano}`,
                  dados: _vm.dadosPieChartEsporte,
                  "is-get-svg": _vm.isGetSvg.esporte.pie,
                },
                on: { svg: (value) => (_vm.svg.esporte.pie = value) },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("app-title", {
                attrs: {
                  texto: "RESULTADOS: INSTRUTOR DE ESPORTE",
                  cor: "secondary",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("tabela-resultado-instrutor", {
                attrs: {
                  relatorio: _vm.relatorio,
                  titulo: "Esporte",
                  icone: "directions_bike",
                  "interesses-attr": "areasEsporte",
                  "is-instrutor-attr": "isInstrutorEsporte",
                  "cursos-attr": "cursosEsporte",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-end mb-1" },
        [
          _c(
            VTooltip,
            {
              attrs: { "max-width": "400", top: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        VBtn,
                        _vm._g(
                          {
                            attrs: { color: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.getRelatorio()
                              },
                            },
                          },
                          on
                        ),
                        [
                          _c(VIcon, [_vm._v("get_app")]),
                          _vm._v(" BAIXAR PDF "),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _c("span", [
                _vm._v(
                  "Clique para baixar o relatório dos dados em formato PDF."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }